import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  appLoading: false,
  viewFilter: {}
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    updateAppLoading: (state, action) => {
      state.appLoading = action.payload;
    },
    updateViewFilter: (state, action) => {
      const { viewName, filterValue } = action.payload;
      state.viewFilter[viewName] = filterValue;
    }
  }
});

// Action creators are generated for each case reducer function
export const { updateAppLoading, updateViewFilter } = appSlice.actions;

export default appSlice.reducer;
